<template>
  <div class="ai-chat-container">
    <!-- 聊天消息区域 -->
    <div class="chat-messages" ref="chatMessages">
      <!-- 系统欢迎语 -->
      <div v-if="messages.length === 0" class="message ai-message">
        <div class="avatar">🤖</div>
        <div class="content">{{ formatMessage('你好！我是 AI 助手，有什么可以帮助你的吗？') }}</div>
      </div>

      <!-- 聊天记录 -->
      <div 
        v-for="(msg, index) in messages" 
        :key="index" 
        :class="['message', msg.role === 'user' ? 'user-message' : 'ai-message']"
      >
        <div class="avatar">{{ msg.role === 'user' ? '👤' : '🤖' }}</div>
        <!-- 原生JS格式化，避免v-html可能的问题 -->
        <!--<div class="content">{{ formatMessage(msg.content) }}</div>-->
         <div class="content" v-html="formatMessage(msg.content)"></div>
      </div>

      <!-- AI 加载中状态 -->
      <div v-if="isLoading" class="message ai-message">
        <div class="avatar">🤖</div>
        <div class="content loading">
          <span>.</span><span>.</span><span>.</span>
        </div>
      </div>
    </div>

    <!-- 输入区域 -->
    <div class="chat-input">
      <input
        v-model="inputMessage"
        type="text"
        placeholder="请输入你的问题..."
        @keyup.enter="sendMessage"
        :disabled="isLoading"
      >
      <button @click="sendMessage" :disabled="!inputMessage.trim() || isLoading">
        {{ isLoading ? '发送中...' : '发送' }}
      </button>
    </div>
  </div>
</template>

<script>
import {Form, Message} from 'element-ui';
// 纯原生JS，无任何第三方依赖
export default {
  name: 'AIChatBox',
  data() {
    return {
      messages: [],     // 聊天消息列表
      inputMessage: '', // 输入框内容
      isLoading: false  // 加载状态
    }
  },
  methods: {
    // 发送消息核心逻辑
    sendMessage() {
      // 过滤空输入
      const message = this.inputMessage.trim()
      if (!message || this.isLoading) return

      // 添加用户消息
      this.messages.push({
        role: 'user',
        content: message
      })

      // 清空输入框，开启加载
      this.inputMessage = ''
      this.isLoading = true


     let self = this;
  

        self.postRequest('/ai/chat',{'body':message}).then(resp =>{
          
                this.isLoading = false
                 self.messages.push({
                  role: 'ai',
                  content: resp
                });
            })



    },


 // 核心：原生JS格式化AI返回数据（解决格式混乱）
    formatMessage(content) {
      if (!content) return ''
      
      let formatted = content
        // 1. 移除首尾多余空格/换行（清理冗余）
        .trim()
        // 2. 处理换行：单个\n→<br>，多个\n→保留一个<br>（避免空行过多）
        .replace(/\n+/g, '\n')
        .replace(/\n/g, '<br>')
        // 3. 处理数字列表：1. xxx → <li class="num-item">xxx</li>（包裹成有序列表）
        .replace(/(\d+)\. (.*?)(?=<br>|$)/g, (match, num, text) => {
          return `<li class="num-item">${num}. ${text}</li>`
        })
        // 4. 处理符号列表：- xxx → <li class="bullet-item">xxx</li>（包裹成无序列表）
        .replace(/- (.*?)(?=<br>|$)/g, (match, text) => {
          return `<li class="bullet-item">${text}</li>`
        })
        // 5. 处理加粗：**xxx** → <strong>xxx</strong>
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        // 6. 处理单行代码：`xxx` → <code class="inline-code">xxx</code>
        .replace(/`([^`\n]+)`/g, '<code class="inline-code">$1</code>')
        // 7. 处理多行代码块：```xxx``` → <pre><code class="block-code">xxx</code></pre>
        .replace(/```([\s\S]*?)```/g, (match, code) => {
          return `<pre><code class="block-code">${code.trim()}</code></pre>`
        })
        // 8. 处理引用：> xxx → <blockquote>xxx</blockquote>
        .replace(/> (.*?)(?=<br>|$)/g, '<blockquote>$1</blockquote>')
        // 9. 处理标题：## xxx → <h3>$1</h3>
        .replace(/## (.*?)(?=<br>|$)/g, '<h3>$1</h3>')

      // 9. 给列表项包裹<ul>/<ol>（让列表更规整）
      // 匹配连续的数字列表项
      formatted = formatted.replace(/(<li class="num-item">.*?<\/li>)+/g, (match) => {
        return `<ol class="num-list">${match}</ol>`
      })
      // 匹配连续的符号列表项
      formatted = formatted.replace(/(<li class="bullet-item">.*?<\/li>)+/g, (match) => {
        return `<ul class="bullet-list">${match}</ul>`
      })

      return formatted
    },
    // 滚动到消息底部
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.chatMessages
        if (container) {
          container.scrollTop = container.scrollHeight
        }
      })
    }
  }
}
</script>

<style>
/* 移除scoped，避免样式失效；纯原生CSS，无复杂样式 */
.ai-chat-container {
  width: 100%;
  max-width: 1200px;
  margin: 20px auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  font-family: Arial, sans-serif;
}

.chat-messages {
  height: 800px;
  padding: 20px;
  overflow-y: auto;
  background-color: #f9fafb;
}

.message {
  display: flex;
  margin-bottom: 16px;
  align-items: flex-start;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  margin-right: 12px;
  flex-shrink: 0;
}

.content {
  background-color: white;
  padding: 10px 16px;
  border-radius: 18px;
  max-width: 70%;
  line-height: 1.5;
  font-size: 14px;
  white-space: pre-wrap;
}

/* 用户消息样式 */
.user-message {
  flex-direction: row-reverse;
}
.user-message .avatar {
  margin-right: 0;
  margin-left: 12px;
  background-color: #3b82f6;
  color: white;
}
.user-message .content {
  background-color: #3b82f6;
  color: white;
}

/* AI消息样式 */
.ai-message .content {
  background-color: #ffffff;
  color: #374151;
}

/* 加载动画 */
.loading {
  display: flex;
  gap: 4px;
  align-items: center;
}
.loading span {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #9ca3af;
  animation: loading 1s infinite ease-in-out;
}
.loading span:nth-child(2) { animation-delay: 0.2s; }
.loading span:nth-child(3) { animation-delay: 0.4s; }
@keyframes loading {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

/* 输入区域 */
.chat-input {
  display: flex;
  padding: 16px;
  background-color: white;
  border-top: 1px solid #e5e7eb;
}
.chat-input input {
  flex: 1;
  padding: 10px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 24px;
  outline: none;
  font-size: 14px;
  margin-right: 12px;
}
.chat-input input:focus {
  border-color: #3b82f6;
}
.chat-input button {
  padding: 10px 24px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 24px;
  cursor: pointer;
  font-size: 14px;
}
.chat-input button:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}
</style>